class ProductSlider extends HTMLElement {
  constructor() {
    super();
    this.viewport = this.querySelector('.product-slider__viewport');
    this.prevBtn = this.querySelector('.product-slider__arrow--prev');
    this.nextBtn = this.querySelector('.product-slider__arrow--next');
  }
 
  connectedCallback() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.scrollByCard(-1));
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.scrollByCard(1));
    }
 
    // Sélecteur de variante -> met à jour l'id caché du formulaire + prix + bouton
    this.querySelectorAll('.product-slider__select').forEach((select) => {
      select.addEventListener('change', (event) => {
        const form = event.target.closest('form');
        if (!form) return;
 
        const hiddenInput = form.querySelector('.product-slider__variant-id');
        if (hiddenInput) hiddenInput.value = event.target.value;
 
        const dataScript = form.querySelector('.product-slider__variant-data');
        if (!dataScript) return;
 
        let variants;
        try {
          variants = JSON.parse(dataScript.textContent);
        } catch (e) {
          return;
        }
 
        const selectedVariant = variants.find((v) => String(v.id) === String(event.target.value));
        if (!selectedVariant) return;
 
        const priceEl = form.querySelector('.product-slider__price');
        const comparePriceEl = form.querySelector('.product-slider__price-compare');
        const button = form.querySelector('.product-slider__add-btn');
        const buttonTextEl = form.querySelector('.product-slider__add-btn-text');
 
        if (priceEl) priceEl.textContent = selectedVariant.price;
 
        if (comparePriceEl) {
          if (selectedVariant.comparePrice) {
            comparePriceEl.textContent = selectedVariant.comparePrice;
            comparePriceEl.hidden = false;
          } else {
            comparePriceEl.textContent = '';
            comparePriceEl.hidden = true;
          }
        }
 
        if (button) {
          button.disabled = !selectedVariant.available;
          const addText = button.dataset.addText || 'Ajouter au panier';
          const soldOutText = button.dataset.soldOutText || 'Épuisé';
          const label = selectedVariant.available ? addText : soldOutText;
          if (buttonTextEl) {
            buttonTextEl.textContent = label;
          } else {
            button.textContent = label;
          }
        }
      });
    });
 
    // Ajout au panier en AJAX, sans recharger la page
    this.querySelectorAll('form[data-product-form]').forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const button = form.querySelector('.product-slider__add-btn');
        const buttonTextEl = button.querySelector('.product-slider__add-btn-text');
        const setLabel = (text) => {
          if (buttonTextEl) {
            buttonTextEl.textContent = text;
          } else {
            button.textContent = text;
          }
        };
        const originalText = buttonTextEl ? buttonTextEl.textContent : button.textContent;
        const formData = new FormData(form);
 
        button.disabled = true;
        setLabel('Ajout...');
 
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' },
        })
          .then((response) => response.json())
          .then(async (data) => {
            if (data.status) {
              setLabel('Indisponible');
              button.disabled = false;
              return;
            }
 
            setLabel('Ajouté ✓');
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
 
            // On met à jour le panier (drawer) en AJAX, sans recharger la page.
            //
            // Important : simplement appeler cartItemsComponent.fetchCartData() ne
            // suffit pas — cette méthode se contente de relire /cart.js, elle ne
            // redessine jamais le contenu du drawer. Le drawer natif ne se
            // redessine correctement (notamment le passage "panier vide" -> "1er
            // article ajouté") que si on remplace tout le contenu de la section
            // via l'API de rendu de sections Shopify (/?sections=...), puis qu'on
            // met à jour "à la main" la pastille du panier dans le header (elle
            // vit dans une autre section et n'est pas incluse dans celle du
            // drawer).
            try {
              const cartItemsComponent = document.querySelector('cart-items-component');
              const sectionId = cartItemsComponent ? cartItemsComponent.sectionId : 'cart-drawer-section';
 
              const sections = await fetch('/?sections=' + sectionId).then((r) => r.json());
              const html = sections[sectionId];
              const wrapper = document.getElementById('shopify-section-' + sectionId);
              if (html && wrapper) {
                wrapper.innerHTML = html;
              }
 
              const cart = await fetch('/cart.js').then((r) => r.json());
              const bubble = document.querySelector('.cart-bubble');
              const bubbleCount = document.querySelector('.cart-bubble__text-count');
              if (bubble && bubbleCount) {
                bubbleCount.textContent = cart.item_count;
                bubble.classList.toggle('visually-hidden', cart.item_count === 0);
                bubbleCount.classList.toggle('hidden', cart.item_count === 0);
              }
 
              const drawer = document.getElementById('cart-drawer');
              if (drawer && typeof drawer.open === 'function') {
                drawer.open();
              } else {
                // Filet de sécurité si le drawer n'existe pas sur cette page.
                window.location.href = '/cart';
              }
            } catch (e) {
              // Filet de sécurité si l'ouverture AJAX du panier échoue.
              window.location.href = '/cart';
            }
 
            button.disabled = false;
            setTimeout(() => setLabel(originalText), 1500);
          })
          .catch(() => {
            setLabel('Erreur');
            button.disabled = false;
          });
      });
    });
 
    if (this.dataset.autoplay === 'true') {
      const speed = parseFloat(this.dataset.autoplaySpeed || '5') * 1000;
      this.autoplayInterval = setInterval(() => this.scrollByCard(1), speed);
      this.addEventListener('mouseenter', () => clearInterval(this.autoplayInterval));
      this.addEventListener('mouseleave', () => {
        this.autoplayInterval = setInterval(() => this.scrollByCard(1), speed);
      });
    }
  }
 
  scrollByCard(direction) {
    if (!this.viewport) return;
    const card = this.viewport.querySelector('.product-slider__slide');
    if (!card) return;
    const cardWidth = card.getBoundingClientRect().width + 20;
    this.viewport.scrollBy({ left: cardWidth * direction, behavior: 'smooth' });
  }
}
 
customElements.define('product-slider', ProductSlider);
 